<script setup lang="ts">
import { computed } from 'vue'
import { RouterLink, useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const router = useRouter()
const authStore = useAuthStore()

const isAuthenticated = computed(() => authStore.isAuthenticated)
const user = computed(() => authStore.user)

async function handleLogout() {
  await authStore.logout()
  router.push('/')
}
</script>

<template>
  <header class="sticky top-0 z-20 border-b border-white/70 bg-white/85 shadow-sm backdrop-blur">
    <nav class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div class="flex min-h-16 flex-col gap-3 py-3 sm:flex-row sm:items-center sm:justify-between">
        <RouterLink to="/" class="flex items-center gap-2">
          <span class="flex h-9 w-9 items-center justify-center rounded-2xl bg-slate-950 text-lg">🏈</span>
          <span class="text-lg font-black tracking-tight text-slate-950 sm:text-xl">AI Fantasy Football</span>
        </RouterLink>

        <div class="flex flex-wrap items-center gap-3 text-sm">
          <template v-if="isAuthenticated">
            <RouterLink
              to="/dashboard"
              class="font-medium text-slate-700 transition-colors hover:text-emerald-700"
            >
              Draft hub
            </RouterLink>
            <RouterLink
              to="/leagues"
              class="font-medium text-slate-700 transition-colors hover:text-emerald-700"
            >
              Leagues
            </RouterLink>
            <RouterLink
              to="/players"
              class="font-medium text-slate-700 transition-colors hover:text-emerald-700"
            >
              Players
            </RouterLink>
            <RouterLink
              to="/drafts"
              class="font-medium text-slate-700 transition-colors hover:text-emerald-700"
            >
              Drafts
            </RouterLink>
            <RouterLink
              to="/draft-board"
              class="font-medium text-slate-700 transition-colors hover:text-emerald-700"
            >
              Live board
            </RouterLink>
            <RouterLink
              to="/strategy"
              class="font-medium text-slate-700 transition-colors hover:text-emerald-700"
            >
              Strategy
            </RouterLink>
            <span class="max-w-[11rem] truncate text-slate-500 sm:max-w-xs">{{ user?.email }}</span>
            <button class="btn btn-secondary min-h-10 text-sm" @click="handleLogout">
              Logout
            </button>
          </template>
          <template v-else>
            <RouterLink
              to="/login"
              class="font-medium text-slate-700 transition-colors hover:text-emerald-700"
            >
              Login
            </RouterLink>
            <RouterLink to="/register" class="btn btn-primary min-h-10">
              Join beta
            </RouterLink>
          </template>
        </div>
      </div>
    </nav>
  </header>
</template>
